import {
  POST,
  GET
} from '@/axios/axios'

export const services = {
  SystemUserList: (param) => { // 用户管理-系统用户列表
    return GET("/backend/user/queryByPage", param);
  },
  SystemUserAddEdit: (param) => { // 用户管理-系统用户-新增/修改
    return POST("/backend/user/saveOrUpdateUserAndRole", param);
  },
  SystemUserDelete: (param) => { // 用户管理-系统用户-删除
    return GET("/backend/user/delete", param);
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/systemUser.js